jQuery(function($){

	$('.sc-field-editor').on('click', '.field.typeahead[field_name="full_mix_download"] .select-popup-button.create-new', function(e){
		e.stopPropagation();
		verifyValidPrerequisiteFields($(this), e);
	});

	$('.sc-field-editor').on('click', '.field.typeahead[field_name="all_tracks_download"] .select-popup-button.create-new', function(e){
		e.stopPropagation();
		verifyValidPrerequisiteFields($(this), e);
	});

	function verifyValidPrerequisiteFields(el, e) {
		const parentField = el.closest('.field.typeahead');

		const invalidFields = parentField.find('.create-new--invalid');
		console.log(invalidFields);
		console.log(invalidFields.length);
		invalidFields.remove();

		let missingFields = [];

		//Song Title Check
		const songTitle = $('[name="post_title"]').val();
		if(!songTitle.length) missingFields.push('Song Title');
		
		//Voicing Title Check
		const voicingTitleFields = el.closest('.array-field-info').find('[field_name="title"]');
		let voicingTitle;
		voicingTitleFields.each(function(){
			const field = $(this).find('[name="' + $(this).attr('full_field_name') + '"]')
			voicingTitle = field.val();
		});
		if(!voicingTitle.length) missingFields.push('Which Voicing?');

		//Arranger Check
		const myArrangement = $('[name="sc-fields[my_arrangement]"]').val();
		const arrangers = $('[name="sc-fields[arrangers]"]').val();
		if(!myArrangement.length && (!arrangers.length || arrangers == '[]')) missingFields.push('Arranger(s)/This song is my arrangement');

		//File Check
		const fileValue = el.closest('.add-new-fields').find('input[field_name="new_file"]').val();
		if(!fileValue.length) missingFields.push('File to sell');

		if(missingFields.length) {
			let alertMessage = 'Required fields are missing before a product can be created:';
			let bulletPoint = "\n\u00A0\u2022\u00A0\u00A0";

			$.each(missingFields, function(i, val){
				alertMessage += bulletPoint + val;
			});
			window.alert(alertMessage);

			parentField.append('<input type="hidden" class="create-new--invalid">');
		}
	}
});